import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Portfolj = lazy(() => import("@/pages/elavtal/Portfolj"));

export const Route = createFileRoute("/elavtal/portfolj")({
  head: () => seoHead("/elavtal/portfolj", { description: "Portföljavtal är aktiv elhandelsförvaltning där en specialist köper el i poster för att optimera priset över tid. Vanligt för företag och BRF." }),
  component: () => <Portfolj />,
});
